import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedPlural } from 'react-intl';
import moment from 'moment-timezone';
import { Map } from 'immutable';

import { formatParkingTime, formatParkingDate } from 'lib/checkout/date-time-formatters';

import { Location } from 'models/locations';
import Quote from 'models/quote';

import AutoExtendLabel from 'components/checkout/parking-details/time-picker/auto-extend-label';

const propTypes = {
  timezone: PropTypes.string.isRequired,
  shouldRenderAutoExtendLabel: PropTypes.bool.isRequired,
  directAffiliateTraffic: PropTypes.bool.isRequired,
  bookExtendedTimes: PropTypes.bool.isRequired,
  selectedLocation: PropTypes.instanceOf(Location).isRequired,
  appContext: PropTypes.string.isRequired,
  showAutoExtendTooltip: PropTypes.bool.isRequired,
  selectedQuote: PropTypes.instanceOf(Quote),
  quoteType: PropTypes.string,
  parkingMinStart: PropTypes.instanceOf(moment),
  afterEventEnd: PropTypes.number,
  sellers: PropTypes.instanceOf(Map),
  toggleBookExtendedTimes: PropTypes.func.isRequired,
  toggleAutoExtendTooltip: PropTypes.func.isRequired,
  hideAutoExtendTooltip: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedQuote: new Quote(),
  quoteType: null,
  parkingMinStart: null,
  afterEventEnd: null,
  sellers: Map(),
};

const EventParkingPeriod = ({
  quoteType,
  parkingMinStart,
  afterEventEnd,
  timezone,
  shouldRenderAutoExtendLabel,
  directAffiliateTraffic,
  bookExtendedTimes,
  selectedQuote,
  selectedLocation,
  sellers,
  toggleBookExtendedTimes,
  toggleAutoExtendTooltip,
  appContext,
  showAutoExtendTooltip,
  hideAutoExtendTooltip,
}) => {
  if (quoteType !== 'EventPricing') { return null; }

  return (
    <div>
      <div className="parking-time-details background-color-light-blue row">
        <div className="parking-start col-md-6 col-xs-12">
          <div className="details">
            <p>
              <FormattedMessage
                id="checkout.park-after"
                defaultMessage="Park anytime after"
              />
            </p>
            <p className="booking-time">{formatParkingTime(parkingMinStart.format(), timezone)}</p>
            <p>{formatParkingDate(parkingMinStart.format(), timezone)}</p>
          </div>
        </div>
        <div className="parking-end col-md-6 col-xs-12">
          <div className="details">
            <p>
              <FormattedMessage
                id="checkout.event-exit-within"
                defaultMessage="Exit within"
              />
            </p>
            <p className="booking-time">
              {`${afterEventEnd} `}
              <FormattedPlural
                value={afterEventEnd}
                one="hour"
                other="hours"
              />
            </p>
            <p>
              <FormattedMessage
                id="checkout.after-event"
                defaultMessage="after event"
              />
            </p>
          </div>
        </div>
      </div>
      <AutoExtendLabel
        shouldRender={shouldRenderAutoExtendLabel}
        directAffiliateTraffic={directAffiliateTraffic}
        bookExtendedTimes={bookExtendedTimes}
        timezone={timezone}
        selectedQuote={selectedQuote}
        selectedLocation={selectedLocation}
        sellers={sellers}
        toggleBookExtendedTimes={toggleBookExtendedTimes}
        toggleAutoExtendTooltip={toggleAutoExtendTooltip}
        appContext={appContext}
        showAutoExtendTooltip={showAutoExtendTooltip}
        hideAutoExtendTooltip={hideAutoExtendTooltip}
      />
    </div>
  );
};

EventParkingPeriod.propTypes = propTypes;
EventParkingPeriod.defaultProps = defaultProps;
export default EventParkingPeriod;
